import { render, staticRenderFns } from "./InstanceTab.vue?vue&type=template&id=03723358"
import script from "./InstanceTab.vue?vue&type=script&lang=js"
export * from "./InstanceTab.vue?vue&type=script&lang=js"
import style0 from "./InstanceTab.vue?vue&type=style&index=0&id=03723358&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports